<div class="px-5 mx-auto md:max-w-[960px] lg:max-w-[1120px]">
  <slot />
</div>